var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32422 25.8053C4.60029 22.6594 5.43118 19.3509 5.79283 15.9754L6.07929 13.3021M21.9201 13.3014L22.2066 15.9755C22.5686 19.3538 23.4006 22.665 24.6785 25.8132M10.0163 13.2033C9.75248 16.6335 8.94136 19.9994 7.61375 23.1732L6.43127 26M10.0163 13.2033C8.91637 13.2033 8.02463 12.3116 8.02463 11.2116V10.0166H12.008M10.0163 13.2033C11.1163 13.2033 12.008 12.3116 12.008 11.2116M17.9831 13.2033C18.247 16.6335 19.0581 19.9994 20.3857 23.1732L21.5682 26M17.9831 13.2033C16.8832 13.2033 15.9914 12.3116 15.9914 11.2116M17.9831 13.2033C19.0831 13.2033 19.9748 12.3116 19.9748 11.2116V10.0166H15.9914M12.008 10.0166V11.2116M12.008 10.0166H15.9914M12.008 11.2116C12.008 12.3116 12.8998 13.2033 13.9997 13.2033C15.0997 13.2033 15.9914 12.3116 15.9914 11.2116M15.9914 10.0166V11.2116",
    stroke: "#3936EF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32013 10.0166H8.0249V11.2116C8.0249 12.3116 7.13316 13.2033 6.0332 13.2033C4.93323 13.2033 4.04149 12.3116 4.04149 11.2116V10.0166L5.03495 9.51987C8.57193 7.75138 11.6431 5.17532 14 2C16.3569 5.17532 19.4281 7.75138 22.965 9.51987L23.9585 10.0166V11.2116C23.9585 12.3116 23.0668 13.2033 21.9668 13.2033C20.8668 13.2033 19.9751 12.3116 19.9751 11.2116V10.0166H23.6142M2 26H26M9.29978 25.884C11.1139 23.2387 12.5786 20.37 13.6574 17.3492L14 16.39L14.3426 17.3492C15.4219 20.3713 16.8873 23.2411 18.7025 25.8874",
    stroke: "#3936EF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.c294d7620091f1726bf50fc8e312c2b0.svg";
export { ForwardRef as ReactComponent };